<template>
  <Dialog v-model:open="opened">
    <DialogContent v-if="confirmDialogData" class="sm:max-w-[425px]">
      <DialogHeader>
        <div>
          <DialogTitle>{{ confirmDialogData.header }}</DialogTitle>
        </div>
      </DialogHeader>

      <DialogDescription>
        <p v-html="confirmDialogData.message"></p>
      </DialogDescription>

      <DialogFooter>
        <Button
          ref="cancelButtonRef"
          type="button"
          variant="outline"
          @click="onCancel"
        >
          {{ confirmDialogData.cancel ? confirmDialogData.cancel : "Cancel" }}
        </Button>

        <Button
          type="button"
          :variant="
            confirmDialogData.type === 'danger' ? 'destructive' : 'default'
          "
          @click="onSuccess"
        >
          {{
            confirmDialogData.confirm ? confirmDialogData.confirm : "Confirm"
          }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { useConfirmDialog } from "..";
import { Button } from "../../button/";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../dialog";

const { opened, confirmDialogData } = useConfirmDialog();
const { $emitter } = useNuxtApp();

const inputData = ref("");

const onCancel = () => {
  if ($emitter === undefined) {
    return;
  }

  $emitter.emit("dialog-canceled");
};

const onSuccess = () => {
  if ($emitter === undefined) {
    return;
  }

  if (inputData.value === "") {
    $emitter.emit("dialog-confirmed");
  } else {
    $emitter.emit("dialog-confirmed", inputData.value);

    inputData.value = "";
  }
};
</script>
